import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Popconfirm } from 'antd';
import Button from 'components/Shared/Common/Button';
import { injectIntl } from 'react-intl';

const PopConfirmComponent = memo(
    injectIntl(({ intl, title, placement = 'right', onConfirm, ...props }) => (
        <Popconfirm
            placement={placement}
            title={title}
            onConfirm={onConfirm}
            okText={intl.formatMessage({ id: 'button.toggle.on' })}
            cancelText={intl.formatMessage({ id: 'button.toggle.off' })}
            {...props}
        />
    ))
);

PopConfirmComponent.propTypes = {
    placement: PropTypes.string,
    intl: PropTypes.any.isRequired,
    title: PropTypes.string.isRequired,
    onConfirm: PropTypes.func.isRequired
};

const PopConfirm = injectIntl(PopConfirmComponent);
export default PopConfirmComponent;

export const PopConfirmDeletion = memo(
    ({
        title,
        placement,
        onConfirm,
        buttonColor = 'error',
        buttonIconName = 'XCircle',
        buttonTitle,
        buttonSize = 'xs',
        isTransparent = true,
        disabled = false,
        buttonTestId,
        ...props
    }) => (
        <PopConfirm
            placement={placement}
            title={title}
            onConfirm={onConfirm}
            disabled={disabled}
            {...props}
        >
            <Button
                iconName={buttonIconName}
                color={buttonColor}
                isTransparent={isTransparent}
                size={buttonSize}
                disabled={disabled}
                data-testid={buttonTestId}
            >
                {buttonTitle}
            </Button>
        </PopConfirm>
    )
);

PopConfirmDeletion.propTypes = {
    buttonTestId: PropTypes.string,
    placement: PropTypes.string,
    title: PropTypes.string.isRequired,
    buttonColor: PropTypes.string,
    buttonTitle: PropTypes.string,
    disabled: PropTypes.bool,
    isTransparent: PropTypes.bool,
    onConfirm: PropTypes.func.isRequired,
    buttonIconName: PropTypes.oneOf(['MinusCircle', 'XCircle', 'Trash2']),
    buttonSize: PropTypes.string
};
